module.exports = __webpack_public_path__ + "7755e0b7d5e0b7b36988727d5caa649a.png";